import {
    useMemo,
} from 'react'
import {
    Navigate,
} from 'react-router-dom'

import {
    SkyNetRouteConfigObject, useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import {
    DamageTrackingDomains,
} from 'app/enums/domain.enums'
import {
    CommonRoutes,
} from 'app/enums/common.enums'

import useDamageTrackingRoutes from 'app/SkyNetRoutes/hooks/useDamageTrackingRoutes'
import Damages from './Damages'
import DamageTypes from './DamageTypes'

export default function DamageTracking() {
    const Routes = useDamageTrackingRoutes()

    const routesConfig: SkyNetRouteConfigObject<DamageTrackingDomains> = useMemo(() => {
        return {
            [Routes.Damages.route]: <Damages />,
            [Routes.DamageTypes.route]: <DamageTypes />,
            [CommonRoutes.Slash]: <Navigate
                to={Routes.Damages.route}
                replace
            />,
        }
    }, [Routes])

    return useSkyNetRoutes({
        routesConfig,
    })
}
